/**
 * Preview access. Change PREVIEW_PASSWORD to whatever you want to share with reviewers.
 *
 * Note: this is a client-side gate, so it keeps casual visitors out of a shared preview link.
 * It is not real security, since the check runs in the browser.
 */
export const PREVIEW_PASSWORD = "zeeshan2026";

/** Flip to true to put the shared preview behind the password screen again. */
export const PREVIEW_LOCK_ENABLED = false;

export const ACCESS_STORAGE_KEY = "smz-preview-access";

export function isUnlocked() {
  try {
    return window.localStorage.getItem(ACCESS_STORAGE_KEY) === "granted";
  } catch {
    return false;
  }
}

export function grantAccess() {
  try {
    window.localStorage.setItem(ACCESS_STORAGE_KEY, "granted");
  } catch {
    // Storage can be unavailable in private modes. The session still unlocks in memory.
  }
}
